<template>
  <a-form-item>
    <span slot="label">
      {{ label }}
      <a-tooltip
        v-if="outOfRange"
        :title="`Fora da faixa atual da base (${min} a ${max}).`"
      >
        <a-icon type="exclamation-circle" class="range-slider-warning" />
      </a-tooltip>
    </span>
    <a-slider
      :value="sliderValue"
      range
      :min="min"
      :max="max"
      @change="updateRange"
    />

    <a-row :gutter="8" class="range-slider-inputs">
      <a-col :span="12">
        <a-input-number
          :value="value[0]"
          :class="{ 'is-out-of-range': isOutOfRange(value[0]) }"
          style="width:100%"
          @change="updateMin"
        />
      </a-col>

      <a-col :span="12">
        <a-input-number
          :value="value[1]"
          :class="{ 'is-out-of-range': isOutOfRange(value[1]) }"
          style="width:100%"
          @change="updateMax"
        />
      </a-col>
    </a-row>
  </a-form-item>
</template>
<script>
export default {
  name: 'RangeSliderFilter',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: {
      type: Array,
      default: () => [0, 100]
    },

    label: {
      type: String,
      required: true
    },

    min: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: 100
    }
  },

  computed: {
    sliderValue() {
      return this.value.map((bound) =>
        Math.min(Math.max(bound ?? this.min, this.min), this.max)
      );
    },

    outOfRange() {
      return this.value.some((bound) => this.isOutOfRange(bound));
    }
  },

  methods: {
    isOutOfRange(bound) {
      return typeof bound === 'number' && (bound < this.min || bound > this.max);
    },

    updateRange(value) {
      this.$emit('input', value);
    },

    updateMin(value) {
      const bound = this.typedBound(value, this.min);

      if (bound !== undefined) {
        this.$emit('input', [bound, this.value[1]]);
      }
    },

    updateMax(value) {
      const bound = this.typedBound(value, this.max);

      if (bound !== undefined) {
        this.$emit('input', [this.value[0], bound]);
      }
    },

    typedBound(value, fallback) {
      if (value === null || value === undefined || value === '') {
        return fallback;
      }

      return typeof value === 'number' ? value : undefined;
    }
  }
};
</script>
<style scoped>
.range-slider-inputs {
    margin-top: 12px;
}

.range-slider-warning {
    margin-left: 4px;
    color: #faad14;
    cursor: help;
}

.is-out-of-range {
    border-color: #faad14;
}
</style>
